import ExtendableError from '../lib/ExtendableError';

export class DisruptionAlertsLimitExceededError extends ExtendableError { name = 'DisruptionAlertsLimitExceededError'; }
export class DisruptionAlertsSecurityCheckFailureError extends ExtendableError { name = 'DisruptionAlertsSecurityCheckFailureError'; }
export class DisruptionAlertsMuteTokenExpiredError extends ExtendableError { name = 'DisruptionAlertsMuteTokenExpiredError'; }
export class DisruptionAlertsAlreadyMutedError extends ExtendableError { name = 'DisruptionAlertsAlreadyMutedError'; }
